import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/layout/Header.scss';
import '../../styles/layout/LandingPage.scss';
import MenuIcon from '@mui/icons-material/Menu';
import { Button } from '@mui/material';

const services = [
  {
    name: "Advanced AI",
    link: "/AdvancedAI",
    defaultImg: "/assets/header/servicesDropDownImages/AdvanceAI_grey.png",
    hoverImg: "/assets/header/servicesDropDownImages/AdvanceAI.png",
    subMenu: [
      { name: "Data Science", link: "/AI_DataScience", img: "/assets/header/servicesDropDownImages/AdvanceAI/DataScience.png" },
      { name: "Text Analytics", link: "/AI_TextAnalysis", img: "/assets/header/servicesDropDownImages/AdvanceAI/TextAnalytics.png" },
      { name: "Computer Vision", link: "/AI_ComputerVision", img: "/assets/header/servicesDropDownImages/AdvanceAI/ComputerVision.png" },
      { name: "Predictive Analysis", link: "/AI_PredictiveAnalysis", img: "/assets/header/servicesDropDownImages/AdvanceAI/PredictiveAnalysis.png" },
      { name: "Generative AI", link: "/GenerativeAI", img: "/assets/header/servicesDropDownImages/AdvanceAI/GenerativeAI.png" },
    ]
  },
  {
    name: "Big Data",
    link: "/BigData",
    defaultImg: "/assets/header/servicesDropDownImages/BigData_grey.png",
    hoverImg: "/assets/header/servicesDropDownImages/BigData.png",
    subMenu: [
      { name: "Data Lake", link: "/DataLake", img: "/assets/header/servicesDropDownImages/BigData/DataLake.png" },
      { name: "Data Warehouse", link: "/DataWarehouse", img: "/assets/header/servicesDropDownImages/BigData/DataWarehouse.png" },
      { name: "Data Integration", link: "/DataIntegration", img: "/assets/header/servicesDropDownImages/BigData/DataIntegration.png" },
    ]
  },
  {
    name: "Data Analytics",
    link: "/DataAnalytics",
    defaultImg: "/assets/header/servicesDropDownImages/DataAnalytics_grey.png",
    hoverImg: "/assets/header/servicesDropDownImages/DataAnalytics.png",
    subMenu: [
      { name: "Tableau", link: "/Tableau", img: "/assets/header/servicesDropDownImages/DataAnalytics/Tableau.png" },
      { name: "Power BI", link: "/PowerBI", img: "/assets/header/servicesDropDownImages/DataAnalytics/PowerBI.png" },
    ]
  },
  {
    name: "Product Engineering",
    link: "/ProductEngineering",
    defaultImg: "/assets/header/servicesDropDownImages/ProductEng_grey.png",
    hoverImg: "/assets/header/servicesDropDownImages/ProductEng.png",
    subMenu: [
      { name: "Angular Development", link: "/Angular", img: "/assets/header/servicesDropDownImages/ProductEngineering/Angular.png" },
      { name: "React Development", link: "/Reactjs", img: "/assets/header/servicesDropDownImages/ProductEngineering/React.png" },
      { name: "Python Development", link: "/Python", img: "/assets/header/servicesDropDownImages/ProductEngineering/Python.png" },
    ]
  }
];

const DropdownItem = ({ service, hoveredItem, setHoveredItem }) => (
  <li
    onMouseEnter={() => setHoveredItem(service.name)}
    onMouseLeave={() => setHoveredItem(null)}
  >
    <Link to={service.link}>
      <img
        src={hoveredItem === service.name ? service.hoverImg : service.defaultImg}
        alt={service.name}
        className="header__dropdown-icon"
      />
      {service.name}
    </Link>
    {hoveredItem === service.name && (
      <ul className="header__dropdownSubMenu">
        {service.subMenu.map(sub => (
          <li key={sub.name}>
            <Link to={sub.link}>
              <img src={sub.img} alt={sub.name} className="header__dropdown-icon" />
              {sub.name}
            </Link>
          </li>
        ))}
      </ul>
    )}
  </li>
);

const Header = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [showHam, setShowHam] = useState(false);

  const handleHamMenu = () => {
    setShowHam(!showHam);
  }

  const handleHamMenuClose = () => {
    setShowHam(false);
  }

  return (
    <header className="header"> 
      <div className="header__logo">
        <Link to="/">
          <img src="/assets/logo/logoblack.png" alt="Company Logo" className="header__logo-image" />
        </Link>
      </div>
      <nav className={showHam ? "header_mobile" : "header__nav"}>
        <ul>
          <li
            className="header__nav-item"
            onMouseEnter={() => setDropdownOpen(true)}
            onMouseLeave={() => setDropdownOpen(false)}
          >
            <Link to='/ourservices' onClick={handleHamMenuClose}>Our Services</Link>
            {dropdownOpen && (
              <ul className="header__dropdown">
                {services.map(service => (
                  <DropdownItem key={service.name} service={service} hoveredItem={hoveredItem} setHoveredItem={setHoveredItem} />
                ))}
              </ul>
            )}
          </li>
          <li><Link to='/ourExpertise' onClick={handleHamMenuClose}>Our Expertise</Link></li>
          <li><Link to='/Careers' onClick={handleHamMenuClose}>Careers</Link></li>
          <li><Link to='/aboutus' onClick={handleHamMenuClose}>About Us</Link></li>
        </ul>
      </nav>
      <div className="header__right">
        <div className="header__linkedIn">
          <a href="https://www.linkedin.com/company/tecloq/" target="_blank" rel="noreferrer">
            <img src="/assets/header/linkedIn.png" alt="LinkedIn" className="__imageHref" />
          </a>
        </div>
        <div className="header__getInTouch">
          <Link to='/clientForm'>
            <img src="/assets/header/getInTouch.png" alt="Get In Touch" className="__imageNav" />
          </Link>
        </div>
        <div className='ham-menu'>
            <Button onClick={handleHamMenu}><MenuIcon sx={{ color: '#F005A2' }} /></Button>
        </div>

      </div>
    </header>
  );
};

export default Header;
